<template>
  <main class="pt-24">
    <section id="home">
      <InicioPage />
      <GestaoPage />
      <InicioPage2 />
    </section>

    <section id="funcionalidades">
      <FunçaoPage />
    </section>

    <section id="sobrenos">
      <SobrePage />
      <GestaoPage2 />
    </section>

    <section id="informacoes">
      <PlanosPage />
      <SolutionsSection />
      <HeroPdv />
      <CtaDiagnostico />
    </section>

     <section>
      <PremiosCard />
    </section>
    
    <section>
      <SelosCard />
    </section>

    <section id="experimente">
      <FaqPage />
    </section>
  </main>
</template>

<script>
import InicioPage from "@/components/Inicio/InicioPage.vue";
import InicioPage2 from "@/components/Inicio/InicioPage2.vue";
import FunçaoPage from "@/components/Funcionalidade/FunçaoPage.vue";
import GestaoPage from "@/components/Gestao/GestaoPage.vue";
import GestaoPage2 from "@/components/Gestao/GestaoPage2.vue";
import SobrePage from "@/components/Sobre/SobrePage.vue";
import PlanosPage from "@/components/Planos/PlanosPage.vue";
import FaqPage from "@/components/FAQ/FaqPage.vue";
import SolutionsSection from "@/components/Funcionalidade/SolutionsSection.vue";
import HeroPdv from "@/components/Funcionalidade/HeroPdv.vue";
import CtaDiagnostico from "@/components/Funcionalidade/CtaDiagnostico.vue";
import SelosCard from "@/components/Selos/SelosCard.vue";
import PremiosCard from "@/components/Premios/PremiosCard.vue";

export default {
  name: "HomePage",
  components: {
    InicioPage,
    InicioPage2,
    FunçaoPage,
    GestaoPage,
    GestaoPage2,
    SobrePage,
    PlanosPage,
    FaqPage,
    SelosCard,
    PremiosCard,
    SolutionsSection,
    HeroPdv,
    CtaDiagnostico
  },
};
</script>
